// extracted by mini-css-extract-plugin
export default {"video":"VideoFrameList_video__mwP4L"};